module.exports = __webpack_public_path__ + "media/images/flags/co-59ec93f7d718ebed3779113450fddf23.svg";